module.exports = __webpack_public_path__ + "img/ko_10-0688867.be17dd2b.jpg";